// @ts-nocheck

import { colors } from '@lmc/common/constants'
import { Icon } from '@lmc/ui-kit'
import PropTypes from 'prop-types'
import React from 'react'
import { Icon as OldIcon } from '../Icon'
import { OldButton } from '../OldButton'

export default function IconButton({
  antdIconName,
  children,
  icon,
  iconColor = colors.black,
  iconSize = 18,
  iconStyle,
  iconUrl,
  onClick,
  position = 'left',
  style,
  text,
  ...props
}) {
  const isLeft = position === 'left'
  const isRight = position === 'right'

  const offset = {}
  if (isLeft) offset.marginRight = '0.5em'
  if (isRight) offset.marginLeft = '0.5em'

  const iconStyles = {
    ...offset,
    ...styles.icon,
    ...iconStyle
  }

  const displayIcon = antdIconName ? (
    <Icon name={antdIconName} style={iconStyles} />
  ) : icon || iconUrl ? (
    <OldIcon
      fill={iconColor}
      name={icon}
      size={iconSize}
      style={iconStyles}
      url={iconUrl}
    />
  ) : null

  return (
    <OldButton
      onClick={onClick}
      type="cancel"
      style={{
        ...styles.button,
        ...style
      }}
      {...props}
    >
      <div style={styles.children}>
        {isLeft && displayIcon}
        {text || children}
        {isRight && displayIcon}
      </div>
    </OldButton>
  )
}

IconButton.propTypes = {
  antdIconName: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.number,
  iconStyle: PropTypes.object,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(['left', 'right']),
  style: PropTypes.object,
  text: PropTypes.string
}

const styles = {
  button: {
    color: colors.black,
    textShadow: 'none',
    transition: 'all .2s ease'
  },
  children: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  icon: {
    alignSelf: 'center'
  }
}
